import { useState, useEffect, useCallback } from 'react';
export function useMVVM(props) {
    var value = props.value, defaultViewValue = props.defaultViewValue, onChange = props.onChange, onBlur = props.onBlur, mapModelToView = props.mapModelToView, mapViewToModel = props.mapViewToModel;
    var _a = useState(typeof value !== 'undefined'
        ? mapModelToView(value, defaultViewValue)
        : defaultViewValue), view = _a[0], setView = _a[1];
    useEffect(function () {
        var nextView = typeof value !== 'undefined'
            ? mapModelToView(value, view)
            : defaultViewValue;
        if (nextView === view) {
            return;
        }
        setView(nextView);
    }, [value, defaultViewValue, mapModelToView]);
    var handleChange = useCallback(function (nextView, e) {
        setView(nextView);
        var nextModel = mapViewToModel(nextView);
        onChange && onChange(nextModel, e);
    }, [mapViewToModel]);
    var handleBlur = useCallback(function (nextView, e) {
        setView(nextView);
        onBlur && onBlur(mapViewToModel(nextView), e);
    }, [mapViewToModel]);
    return {
        value: view,
        onChange: handleChange,
        onBlur: handleBlur,
    };
}
